/**
 * /preview session guard (Lane Q6; EIGENAPP-PREVIEW-PROTOCOL.md section 4).
 *
 * The /preview route NEVER holds a session: no authStore reads, no
 * core.fromToken, no PocketBase requests. Session-bearing postMessage types
 * (REFRESH_RESULT, AUTH, LOGOUT) MUST be REFUSED while on /preview - a hard
 * error log and no state change. This is an EXPLICIT guard (enforced centrally
 * in PostMessageService and again in the individual handlers), not just an
 * absence of handlers.
 */

/** Message types that carry or mutate session state. */
export const SESSION_MESSAGE_TYPES: readonly string[] = [
  "REFRESH_RESULT",
  "AUTH",
  "LOGOUT",
];

/** True when the SPA is currently on the /preview surface (hash router). */
export function isPreviewContext(): boolean {
  const hash = globalThis.location?.hash ?? "";
  return (
    hash === "#/preview" ||
    hash === "#/preview/" ||
    hash.startsWith("#/preview/") ||
    hash.startsWith("#/preview?")
  );
}

/**
 * Returns true (and logs a hard error) when `messageType` is a session
 * message arriving while on /preview. Callers MUST drop the message.
 */
export function refuseSessionMessageOnPreview(messageType: string): boolean {
  if (!SESSION_MESSAGE_TYPES.includes(messageType)) return false;
  if (!isPreviewContext()) return false;

  console.error(
    `[PreviewGuard] ${messageType} REFUSED on /preview: the preview context never holds a session ` +
      "(EIGENAPP-PREVIEW-PROTOCOL.md section 4). No state was changed."
  );
  return true;
}
